export const NOTE_BOX_KEYS = {
  SELLER_PRODUCT_MANAGEMENT_GUIDE: 'SELLER_PRODUCT_MANAGEMENT_GUIDE',
  SELLER_REFUND_MANAGEMENT_GUIDE: 'SELLER_REFUND_MANAGEMENT_GUIDE',
  SELLER_PROFILE_EDIT_GUIDE: 'SELLER_PROFILE_EDIT_GUIDE',

  MY_CART_GUIDE: 'MY_CART_GUIDE',
  MY_DEVICE_GUIDE: 'MY_DEVICE_GUIDE',
  MY_ORDER_HISTORY_GUIDE: 'MY_ORDER_HISTORY_GUIDE',
  MY_REFUND_HISTORY_GUIDE: 'MY_REFUND_HISTORY_GUIDE',
  MY_TOKEN_HISTORY_GUIDE: 'MY_TOKEN_HISTORY_GUIDE',
  MY_LICENSE_GUIDE: 'MY_LICENSE_GUIDE',
  MY_SELLER_REGISTRATION_GUIDE: 'MY_SELLER_REGISTRATION_GUIDE',
  MY_PROFILE_PRIVACY_GUIDE: 'MY_PROFILE_PRIVACY_GUIDE',

  MY_ANALYSIS_REQUESTS_GUIDE: 'MY_ANALYSIS_REQUESTS_GUIDE',
  MY_INQUIRIES_GUIDE: 'MY_INQUIRIES_GUIDE',
} as const;

export type NoteBoxKey = (typeof NOTE_BOX_KEYS)[keyof typeof NOTE_BOX_KEYS];
